import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

// The tasks on one change order. Standalone rather than a member of
// ChangeOrder's EnterpriseObject: the grid is queried by ChangeOrderUSID and must not re-query when
// anything else on the page changes.
class ChangeOrderTaskEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ChangeOrderTask";
        this.primaryEnterpriseComponent = "ChangeOrderTask";

        const eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ChangeOrderTask";
        eom.enterpriseComponent = "ChangeOrderTask";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ChangeOrderTaskEnterpriseObjectMetadata;
